import { render } from "./Reports.vue?vue&type=template&id=2c32e98c&scoped=true&bindings={}"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=2c32e98c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c32e98c"

export default script